// Constants

/**
 * Used in Tag Filters selectors for call flows, they deviate a little from the ones in reporting
 * Might need to refactor this somewhere else once we move other components
 */
export const comparisonTypes = [
  { key: 'EQUALS', value: 'EQUALS', isNegativeMatch: false, forGeoTags: true, forBulkTags: false, forMultipleValues: false },
  { key: 'IN', value: 'DOES_NOT_EQUAL', isNegativeMatch: true, forGeoTags: true, forBulkTags: false, forMultipleValues: false },
  // { key: 'EQUALS', value: 'DOES_NOT_EQUAL', isNegativeMatch: true, forGeoTags: false, forBulkTags: false, forMultipleValues: false },
  { key: 'CONTAINS', value: 'CONTAINS', isNegativeMatch: false, forGeoTags: false, forBulkTags: false, forMultipleValues: false },
  { key: 'CONTAINS', value: 'DOES_NOT_CONTAIN', isNegativeMatch: true, forGeoTags: false, forBulkTags: false, forMultipleValues: false },
  { key: 'BEGINS_WITH', value: 'BEGINS_WITH', isNegativeMatch: false, forGeoTags: false, forBulkTags: false, forMultipleValues: false },
  { key: 'BEGINS_WITH', value: 'DOES_NOT_BEGIN_WITH', isNegativeMatch: true, forGeoTags: false, forBulkTags: false, forMultipleValues: false },
  { key: 'GREATER_THAN', value: 'GREATER_THAN', isNegativeMatch: false, forGeoTags: false, forBulkTags: false, forMultipleValues: false, useNumericalValue: true, },
  { key: 'LESS_THAN', value: 'LESS_THAN', isNegativeMatch: false, forGeoTags: false, forBulkTags: false, forMultipleValues: false, useNumericalValue: true, },
  { key: 'EQUALS', value: 'EQUALS_SINGLE_VALUE', isNegativeMatch: false, forGeoTags: false, forBulkTags: false, forMultipleValues: false, defaultComparisonType: true },
  { key: 'EQUALS', value: 'EQUALS_MULTIPLE_VALUES', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: true },
  { key: 'EQUALS', value: 'DOES_NOT_EQUAL_SINGLE_VALUE', isNegativeMatch: true, forGeoTags: false, forBulkTags: false, forMultipleValues: false },
  { key: 'EQUALS', value: 'DOES_NOT_EQUAL_MULTIPLE_VALUES', isNegativeMatch: true, forGeoTags: false, forBulkTags: true, forMultipleValues: true },
  { key: 'EQUALS', value: 'DOES_NOT_EQUAL_MULTIPLE_VALUES', isNegativeMatch: true, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
  { key: 'EQUALS', value: 'EQUALS_MULTIPLE_VALUES', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
  { key: 'EXISTS', value: 'EXISTS', isNegativeMatch: false, forGeoTags: false, forBulkTags: false, forMultipleValues: false },
  { key: 'EXISTS', value: 'DOES_NOT_EXIST', isNegativeMatch: true, forGeoTags: false, forBulkTags: false, forMultipleValues: false }
];

/**
 * Used in Node Props for Hour Breaks Node
 * Might need to refactor this somewhere else once we move other components
 */
export const hoursOfOperation = [
  {
    breaks: [],
    openTime: { time: '08:00', hour: 8, minute: 0 },
    closeTime: { time: '17:00', hour: 17, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '08:00', hour: 8, minute: 0 },
    closeTime: { time: '17:00', hour: 17, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '08:00', hour: 8, minute: 0 },
    closeTime: { time: '17:00', hour: 17, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '08:00', hour: 8, minute: 0 },
    closeTime: { time: '17:00', hour: 17, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '08:00', hour: 8, minute: 0 },
    closeTime: { time: '17:00', hour: 17, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '08:00', hour: 8, minute: 0 },
    closeTime: { time: '17:00', hour: 17, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  },
  {
    breaks: [],
    openTime: { time: '08:00', hour: 8, minute: 0 },
    closeTime: { time: '17:00', hour: 17, minute: 0 },
    inverted: false,
    isClosed: false,
    isOpen: true
  }
];

/**
 * Used in Node Props for Hour Breaks Node
 * Might need to refactor this somewhere else once we move other components
 */
export const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/**
 * Mapping of each Node type that has an audio setting and the name of the setting param
 */
export const nodeAudioSettingsMap = new Map([
  ['HangupNode', 'message'],
  ['PlayNode', 'message'],
  ['RecordNode', 'message'],
  ['GatherNode', 'prompt'],
  ['MenuNode', 'menuPrompt'],
  ['DialNode', 'whisper']
]);

/**
 * Basic link styles to use when calculating them
 */
export const nodeLinkStyles = {
  defaultStrokeColor: '#687396',
  filterStrokeColor: 'var(--contrast)',
  strokeWidth: 4,
  filterStrokeWidth: 1,
  fillColor: 'none',
  filterFillColor: 'var(--contrast)',
  filterActiveFillColor: '#26CA2C',
  filterErrorFillColor: '#DC3545'
};

/**
 * Fake node to use to represent the root node of the call flow
 */
export const rootNode = {
  id: 'root',
  displayName: 'Inbound Call',
  nodeType: 'Inbound Call',
  nodeTypeId: 'RootNode',
  description: 'The inbound call is the root of the call flow tree.',
  parameters: [],
  potentialLinks: [
    {
      onSuccess: true,
      name: ''
    }
  ],
  nodeOptions: {
    accentColor: '#838685',
    icon: 'fa fa-sitemap',
    size: 'small'
  },
  x: 0,
  y: 0,
  selected: false,
  isValid: true
};

/**
 * Fake node to use if a node is present in the call flow and requires a feature flag that is NOT enabled
 */
export const unavailableNode = {
  id: 'unavailable',
  displayName: 'Unavailable',
  nodeType: 'Unavailable',
  nodeTypeId: 'UnavailableNode',
  description: 'Displayed when a previously available node in the Call Flow is no longer available.',
  parameters: [],
  potentialLinks: [
    {
      onSuccess: true,
      name: ''
    }
  ],
  nodeOptions: {
    accentColor: '#4E4E4E',
    icon: 'fa fa-ban',
  },
  x: 0,
  y: 0,
  selected: false,
  isValid: true
};


/**
 * Empty call flow to use on a new call flow
 */
export const emptyCallFlow = {
  root: {
    id: 'root',
    nodeTypeId: 'RootNode',
    childLinks: [],
    isValid: false,
    settings: {},
    posX: 0,
    posY: 0
  },
  isFinalized: false,
  nodes: {},
  zoom: 1,
  centerX: 0,
  centerY: 0,
  enabled: false
};